import { TableFilterState } from '@ibsys/kit';
import type { SearchRuleFilters } from '@/entities/search';
import { tableFilters2Query } from '@/shared/lib';

/** Builds filters for rule entity (isDeleted, spec: filters by entityType) */
export const buildRuleFilters = (filters: TableFilterState): SearchRuleFilters | undefined => {
  const searchFilters = tableFilters2Query(filters);
  return Object.keys(searchFilters).length > 0 ? (searchFilters as SearchRuleFilters) : undefined;
};
